import { getDataFromSSR } from "@/handlers/client/commonClient";
import useIsMobile from "@/hooks/useIsMobile";
import { useEffect, useState } from "react";

const PlayerStatsCard = ({ tourId, firstTeamName, secondTeamName }) => {
  const bgBatsman = "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/bgBatsman.png";
  const bgBowler = "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/bgBowler.png";
  const orangeCap = "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/orange_cap.png";
  const purpleCap = "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/purple_cap.png";
  const [statData, setStatsData] = useState([]);
  const topBatPerformer = statData?.data?.top_batter ?? [];
  const topBowlingPerformer = statData?.data?.top_bowler ?? [];
  const yearStatsData = statData?.data;
  const [yearDataLoading, setYearDataLoading] = useState(false);
  useEffect(() => {
    const getStatsData = async () => {
      const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
      setYearDataLoading(true);
      let data = await getDataFromSSR(
        `${websiteUrl}/api/getStatsYearlyPerform?tourID=${tourId}`
      );
      setYearDataLoading(false);
      // console.log("statsData", data?.data );
      setStatsData(data?.data);
    };
    getStatsData();
  }, [tourId]);
  const isMobile = useIsMobile();
  const PlayerDetailsCard = ({
    playerId,
    firstName,
    lastName,
    teamName,

    capType,
  }) => {
    return (
      <div className="rounded-lg relative w-full md:h-auto  sm:h-[175px] sm:w-[33%] p-4 z-10 gap-4">
        <div
          className={`absolute inset-0 opacity-20  z-10 ${isMobile ? "pl-[14rem]" : "pl-[5rem]"
            }`}
        >
          <img
            className="h-full"
            src={capType === "purpleCap" ? bgBowler : bgBatsman}
          // style={{ filter: "blur(1.2px)",}}
          />
        </div>

        <div
          className={`absolute inset-0 bg-gradient-to-r ${capType === "purpleCap"
            ? "!from-[#682B7908] !dark:from-[#1f1f1f] !to-[#682B79E5]"
            : "!from-[#ED4D2909] !dark:from-[#1f1f1f] !to-[#ED4D29CC]"
            } rounded-lg z-0`}
        ></div>
        {
          <>
            <img
              className="h-6"
              src={capType === "purpleCap" ? purpleCap : orangeCap}
            />
            <div className="flex justify-around items-end">
              <img
                className="  h-28 z-10"
                src={`https://akm-img-a-in.tosshub.com/sites/sports/ipl/resources_live/images/players_img/ipl_2025/${playerId}.png`}
                onError={(e) => {
                  e.target.src =
                    "https://akm-img-a-in.tosshub.com/sites/sports/ipl/resources_live/images/players_img/ipl_2025/0.png";
                }}
              />
              <div className="text-white md:text-2xl md:my-5 mx-3 z-10 justify-self-end md:w-[50%] w-[40%] text-3xl">
                <span className="font-light">{`${firstName}`}</span>
                <div className="flex font-semibold items-baseline">{`${lastName}`}</div>
                <div className="flex text-[#FFFFFFCC] md:text-lg pt-2 items-center gap-1 text-xl">
                  <img
                    src={` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${teamName?.toLowerCase()}1.png`}
                    alt={teamName}
                    className="w-5 h-5  "
                  />
                  {teamName}
                </div>
              </div>
            </div>
          </>
        }
      </div>
    );
  };

  const StatsBox = ({ data, title, isLoading }) => {
    return (
      <div className="rounded-lg bg-gradient-to-r from-[#FFFFFF] to-[#0000001A] dark:from-[#1f1f1f] dark:to-gray-400/10 flex flex-col justify-center items-center h-[90px] w-[48%] md:w-32">
        <span className="text-[#000000CC] dark:text-[#FFFFFFcc] text-2xl font-medium">
          {data}
        </span>
        <div className="text-lg font-normal text-[#00000080] dark:text-[#FFFFFF80]">
          {title}
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col md:flex-row md:items-start justify-between mt-2   sm:px-0 gap-y-4 md:gap-y-0 md:gap-x-4">
      {/* Batter */}
      <PlayerDetailsCard
        playerId={yearStatsData?.top_batter?.id}
        firstName={(yearStatsData?.top_batter?.name ?? "").replace(
          (yearStatsData?.top_batter?.name ?? "")?.split(" ").pop() ?? "",
          ""
        )}
        lastName={
          (yearStatsData?.top_batter?.name ?? "")?.split(" ").pop() ?? ""
        }
        teamName={firstTeamName}
        capType="orangeCap"
      />

      {/* Stats */}
      <div className="flex flex-col justify-center items-center gap-y-3 w-full md:w-auto">
        <div className="flex gap-2 w-full justify-center">
          <StatsBox
            title="Hundreds"
            data={yearStatsData?.hundreds}
            isLoading={yearDataLoading}
          />
          <StatsBox
            title="Fifties"
            data={yearStatsData?.fiftees}
            isLoading={yearDataLoading}
          />
        </div>
        <div className="flex gap-2 w-full justify-center">
          <StatsBox
            title="Sixes"
            data={yearStatsData?.sixes}
            isLoading={yearDataLoading}
          />
          <StatsBox
            title="Fours"
            data={yearStatsData?.fours}
            isLoading={yearDataLoading}
          />
        </div>
      </div>

      {/* Bowler */}
      <PlayerDetailsCard
        playerId={yearStatsData?.top_bowler?.id}
        firstName={(yearStatsData?.top_bowler?.name ?? "").replace(
          (yearStatsData?.top_bowler?.name ?? "")?.split(" ").pop() ?? "",
          ""
        )}
        lastName={
          (yearStatsData?.top_bowler?.name ?? "")?.split(" ").pop() ?? ""
        }
        teamName={secondTeamName}
        capType="purpleCap"
      />
    </div>
  );
};

export default PlayerStatsCard;
